import { render, staticRenderFns } from "./ChildSupportCurrentArrangement.vue?vue&type=template&id=75f5fbb7"
import script from "./ChildSupportCurrentArrangement.vue?vue&type=script&lang=ts"
export * from "./ChildSupportCurrentArrangement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports